// Translation map for the Wallet & Analytics dashboard area.
// Follows the project convention: (getText) => (key) => ({ ... }[key])
const texts = (getText: (key: string, category: string) => string) => (key: string) =>
  ({
    // Area / header
    title: getText('Wallet & Analytics', 'Wallet'),
    subtitle: getText('Track your earnings, services and invoices', 'Wallet'),

    // Tabs
    financialMetrics: getText('Financial Metrics', 'Wallet'),
    serviceMetrics: getText('Service Metrics', 'Wallet'),
    consultDetails: getText('Consult Details', 'Wallet'),
    invoices: getText('Invoices', 'Wallet'),

    // Time filter
    period: getText('Period', 'Wallet'),
    day: getText('Day', 'Wallet'),
    week: getText('Week', 'Wallet'),
    month: getText('Month', 'Wallet'),
    customRange: getText('Custom Range', 'Wallet'),
    startDate: getText('Start date', 'Wallet'),
    endDate: getText('End date', 'Wallet'),
    invalidRange: getText('Start date must be on or before the end date', 'Wallet'),

    // Onboarding (Req 1.5)
    onboardingTitle: getText('Set up your payout account', 'Wallet'),
    onboardingBody: getText(
      'Connect a payout account to receive money for the consultations you perform.',
      'Wallet'
    ),
    onboardingCta: getText('Start onboarding', 'Wallet'),
    onboardingLoading: getText('Preparing onboarding…', 'Wallet'),
    payoutsUnavailable: getText('Payouts unavailable until onboarding is complete', 'Wallet'),
    onboardingError: getText('Could not start onboarding. Please try again.', 'Wallet'),

    // Stripe wallet link (Req 11)
    openStripeWallet: getText('Open Stripe wallet', 'Wallet'),
    stripeWalletHint: getText('View payout details and manage your payout account', 'Wallet'),
    walletLinkLoading: getText('Opening your Stripe wallet…', 'Wallet'),
    walletLinkError: getText('Could not open your Stripe wallet. Please try again.', 'Wallet'),

    // Financial metrics table (Req 6)
    totalEarnings: getText('Total earnings', 'Wallet'),
    product: getText('Product', 'Wallet'),
    transactions: getText('Transactions', 'Wallet'),
    gross: getText('Gross', 'Wallet'),
    commission: getText('Commission', 'Wallet'),
    net: getText('Net', 'Wallet'),
    refundTotal: getText('Refunds', 'Wallet'),
    refundCount: getText('Refund count', 'Wallet'),

    // Service metrics table (Req 7)
    consultCount: getText('Consultations', 'Wallet'),
    avgDuration: getText('Avg. duration (min)', 'Wallet'),

    // Consult details table (Req 8)
    consultDate: getText('Date', 'Wallet'),
    duration: getText('Duration (min)', 'Wallet'),
    patientInvoice: getText('Patient invoice', 'Wallet'),
    viewConsult: getText('Consult', 'Wallet'),
    productFilter: getText('Product filter', 'Wallet'),
    allProducts: getText('All products', 'Wallet'),
    miaComplete: getText('MIA Complete', 'Wallet'),
    miaBasic: getText('MIA Basic', 'Wallet'),
    nextPage: getText('Next page', 'Wallet'),
    previousPage: getText('Previous', 'Wallet'),

    // Invoices tab (Req 9)
    invoiceMonth: getText('Invoice month', 'Wallet'),
    selectInvoice: getText('Select an invoice', 'Wallet'),
    noInvoices: getText('No invoices available', 'Wallet'),
    invoiceDocument: getText('Invoice document', 'Wallet'),
    openDocument: getText('Open document', 'Wallet'),
    invoiceReference: getText('Reference', 'Wallet'),

    // Generic states
    loading: getText('Loading…', 'Wallet'),
    empty: getText('There are no records to display', 'Wallet'),
    errorLoading: getText('Something went wrong while loading the data.', 'Wallet'),
    none: getText('—', 'Wallet'),
  }[key])

export default texts
